<template>
  <div class="order-empty">
    <img src="../../../assets/imgs/order-empty.png" />
    <p>No packages</p>
  </div>
</template>

<script>
export default {
  name: 'MoveOrderEmpty',
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.order-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 700px;
  img {
    width: 139px;
    height: 119px;
  }
  p {
    .font-light;
    padding-top: 30px;
    font-size: 20px;
    font-weight: 300;
    color: #afb5c6;
    line-height: 24px;
  }
}
</style>
